const Canada = () => {
  return (
    <svg
      style={{ transform: "scale(0.8)" }}
      width="38"
      height="28"
      viewBox="0 0 38 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_5839_108263" maskUnits="userSpaceOnUse" x="0" y="0" width="38" height="28">
        <path
          d="M0 2.42871C0 1.32414 0.89543 0.428711 2 0.428711H36C37.1046 0.428711 38 1.32414 38 2.42871V25.5716C38 26.6761 37.1046 27.5716 36 27.5716H2C0.89543 27.5716 0 26.6761 0 25.5716V2.42871Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_5839_108263)">
        <path d="M0 0.428711H38V27.5716H0V0.428711Z" fill="white" />
        <path d="M27.1426 0.428711H37.9997V27.5716H27.1426V0.428711Z" fill="#FF3131" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 27.5716H10.8571V0.428711H0V27.5716ZM21.8663 12.9443C21.7977 13.0137 21.7086 13.0592 21.6121 13.0737C21.5156 13.0883 21.417 13.0713 21.331 13.0251C21.245 12.979 21.1762 12.9063 21.135 12.8178C21.0937 12.7294 21.0823 12.6299 21.1022 12.5344L21.7143 9.47678L19.9052 10.3806L19 7.66635L18.0948 10.3806L16.2857 9.47678L16.8964 12.5344C16.9159 12.6297 16.9042 12.7287 16.863 12.8167C16.8218 12.9048 16.7533 12.9772 16.6676 13.0232C16.582 13.0693 16.4838 13.0864 16.3876 13.0722C16.2914 13.058 16.2024 13.0131 16.1337 12.9443L15.7008 12.51C15.6588 12.468 15.609 12.4347 15.5542 12.412C15.4993 12.3893 15.4405 12.3776 15.3812 12.3776C15.3218 12.3776 15.263 12.3893 15.2082 12.412C15.1534 12.4347 15.1035 12.468 15.0616 12.51L14.4766 13.0949L12.6662 12.1911L13.5714 14.0001L12.9879 14.5851C12.9459 14.627 12.9126 14.6769 12.8899 14.7317C12.8671 14.7865 12.8554 14.8453 12.8554 14.9047C12.8554 14.964 12.8671 15.0228 12.8899 15.0777C12.9126 15.1325 12.9459 15.1823 12.9879 15.2243L15.3805 17.6196H18.0948L18.5481 20.3339H19.4519L19.9052 17.6196H22.6195L25.0135 15.2243C25.0556 15.1824 25.0891 15.1326 25.1119 15.0778C25.1347 15.0229 25.1465 14.9641 25.1465 14.9047C25.1465 14.8453 25.1347 14.7864 25.1119 14.7316C25.0891 14.6767 25.0556 14.6269 25.0135 14.5851L24.4286 14.0001L25.3338 12.1911L23.5234 13.0949L22.9398 12.5114C22.8978 12.4692 22.8479 12.4357 22.7929 12.4129C22.738 12.39 22.679 12.3783 22.6195 12.3783C22.56 12.3783 22.501 12.39 22.4461 12.4129C22.3911 12.4357 22.3412 12.4692 22.2992 12.5114L21.8649 12.9443H21.8663Z"
          fill="#FF3131"
        />
      </g>
    </svg>
  );
};

export default Canada;
